import React from 'react';
import logoFiresight from '../assets/firesight_logo.png';
import logoVizilink from '../assets/vizilink_logo.png';
import { Domain } from '../types';
import { getDomain } from '../utils/helper';

export function Logo(props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  return <img {...props} src={getDomain() === Domain.firetrol ? logoFiresight : logoVizilink}></img>;
}
